module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', [_c('div', {
    staticClass: "tl"
  }, [_c('default-button', {
    nativeOn: {
      "click": function($event) {
        _vm.goToProductList($event)
      }
    }
  }, [_vm._v("← Back")])], 1)]), _vm._v(" "), (_vm.product) ? _c('div', {
    staticClass: "product"
  }, [_c('content-card', [_c('h2', [_vm._v("Product details")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product.id) ? _c('div', {
    staticClass: "product-form-element product-id"
  }, [_c('label', [_vm._v("Id :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productId),
      expression: "productId"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.productId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productId = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-form-element product-name"
  }, [_c('label', [_vm._v("Name :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.name),
      expression: "product.name"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.product.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-form-element product-description"
  }, [_c('label', [_vm._v("Description :")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.description),
      expression: "product.description"
    }],
    attrs: {
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.product.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-form-element product-images-upload"
  }, [(_vm.product.id) ? [_c('label', [_vm._v("Images upload :")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "disabled": !_vm.product.id || _vm.loading,
      "type": "file",
      "multiple": "",
      "id": "product-details-uploads"
    }
  }), _vm._v(" "), _c('primary-button', {
    nativeOn: {
      "click": function($event) {
        _vm.uploadImages($event)
      }
    }
  }, [_vm._v("Upload")])], 1)] : [_c('label', [_vm._v("Images upload :")]), _vm._v(" "), _c('div', {
    staticClass: "upload-no-new"
  }, [_c('em', [_vm._v("You need to save the product before being able to add images to it")])])]], 2), _vm._v(" "), (_vm.product.id) ? _c('div', {
    staticClass: "product-form-element product-images-gallery"
  }, [_c('label', [_vm._v("Product images :")]), _vm._v(" "), _c('div', {
    staticClass: "product-images tl mt4"
  }, _vm._l((_vm.originalProduct.uploads), function(upload) {
    return _c('div', {
      key: upload.id,
      staticClass: "product-images-item relative"
    }, [_c('img', {
      attrs: {
        "src": upload.link + '/thumbnail?format=small_square',
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "product-images-item-delete pointer absolute right-0 bottom-0",
      on: {
        "click": function($event) {
          _vm.deleteUpload(upload)
        }
      }
    }, [_vm._v("❌")]), _vm._v(" "), _c('div', {
      staticClass: "product-images-item-feature pointer absolute right-2 bottom-0",
      on: {
        "click": function($event) {
          _vm.featureUpload(upload)
        }
      }
    }, [_vm._v(_vm._s(_vm.product.featured && _vm.product.featured._id === upload._id ? '⭐️' : '☆'))])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-form-element product-quantity"
  }, [_c('label', [_vm._v("Quantity :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.stock),
      expression: "product.stock"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.product.stock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "stock", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-form-element product-price"
  }, [_c('label', [_vm._v("Price :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.price),
      expression: "product.price"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.product.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-save tr pt4"
  }, [_c('cancel-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('primary-button', {
    nativeOn: {
      "click": function($event) {
        _vm.saveProduct($event)
      }
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "product-delete tl pt4"
  }, [_c('danger-button', {
    nativeOn: {
      "click": function($event) {
        _vm.deleteProduct($event)
      }
    }
  }, [_vm._v("Delete this product")])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fbeec58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./admin/src/components/ProductDetails.vue
// module id = 255
// module chunks = 0